import { getStandardButtonStyles } from "../../styles/standardButtons";
import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import { i18n } from "../../translate/i18n";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
  ...getStandardButtonStyles(theme),
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  dialogContent: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  formControl: {
    width: "100%",
  },
}));

const FlowBuilderSaveContactModal = ({ open, onSave, onUpdate, close, data }) => {
  const classes = useStyles();
  const [fieldToUpdate, setFieldToUpdate] = useState("name");
  const [variableName, setVariableName] = useState("");

  useEffect(() => {
    if (data) {
      setFieldToUpdate(data.data?.fieldToUpdate || "name");
      setVariableName(data.data?.variableName || "");
    }
  }, [data]);

  const handleSave = () => {
    if (!variableName) {
      toast.error(i18n.t("flowBuilder.editor.nodes.saveContact.errorEmpty"));
      return;
    }
    
    const nodeData = {
      fieldToUpdate,
      variableName
    };

    if (data?.id) {
      onUpdate({
        ...data,
        data: {
          ...data.data,
          ...nodeData
        }
      });
    } else {
      onSave(nodeData);
    }
    
    close();
  };

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth="sm">
      <DialogTitle>{i18n.t("flowBuilder.editor.nodes.saveContact.title")}</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle2" gutterBottom>
              {i18n.t("flowBuilder.editor.nodes.saveContact.fieldToUpdate")}
            </Typography>
            <Select
              fullWidth
              variant="outlined"
              value={fieldToUpdate}
              onChange={(e) => setFieldToUpdate(e.target.value)}
            >
              <MenuItem value={"name"}>{i18n.t("flowBuilder.editor.nodes.saveContact.fields.name")}</MenuItem>
            </Select>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" gutterBottom>
              {i18n.t("flowBuilder.editor.nodes.saveContact.variableName")}
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              value={variableName}
              onChange={(e) => setVariableName(e.target.value)}
              placeholder={i18n.t("flowBuilder.editor.nodes.saveContact.placeholder") || "Ej: step_1_input"}
              helperText={i18n.t("flowBuilder.editor.nodes.saveContact.variableHelper")}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} className={classes.secondaryButton}>
          {i18n.t("flowBuilder.editor.nodes.saveContact.cancel")}
        </Button>
        <Button onClick={handleSave} className={classes.applyButton}>
          {i18n.t("flowBuilder.editor.nodes.saveContact.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderSaveContactModal;
